export default "assets/e9ff64a084db1b3756cfdf7cbae7cf9a.ttf";